import {
  Avatar,
  Divider,
  Group,
  Menu,
  Stack,
  Text,
  ThemeIcon,
  UnstyledButton,
} from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconLogout } from '@tabler/icons';
import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { updateAvatarRequest } from '../../data/services/users';
import { User } from '../../models/user';
import { authActions } from '../../store/auth';
import { userRoleHumanized } from '../../utils/constants';
import { getFullNameInitials } from '../../utils/get-full-name-initials';

interface UserMenuProps {
  user: User;
  onLogout: () => void;
}

export function UserMenu({ onLogout, user }: UserMenuProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();

  /*
  const handleAvatarClick = () => {
    fileInputRef.current?.click();
  };
  */

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      try {
        const response = await updateAvatarRequest(file);
        dispatch(authActions.updateUser(response.data));

        showNotification({
          title: 'Sucesso',
          message: 'Foto de perfil atualizada com sucesso!',
          color: 'green',
        });
      } catch (error) {
        showNotification({
          title: 'Erro',
          message: 'Não foi possível atualizar a foto de perfil.',
          color: 'red',
        });
      }
    }
  };

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        accept="image/*"
        onChange={handleFileChange}
      />
      <Menu position="bottom-end" withArrow>
        <Menu.Target>
          <UnstyledButton>
            <Group>
              <Avatar
                src={user.avatarUrl}
                radius={17.5}
                size={35}
                color="orange"
              >
                {!user.avatarUrl && getFullNameInitials(user.username)}
              </Avatar>
            </Group>
          </UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown miw={220} p="md">
          <Stack align="center" spacing="xs">
            {/* 
            <Indicator
              inline
              size={24}
              offset={7}
              position="bottom-end"
              color="blue"
              withBorder
              label={
                <ActionIcon
                  size="xs"
                  variant="filled"
                  color="blue"
                  radius="xl"
                  onClick={handleAvatarClick}
                >
                  <IconCamera size={16} />
                </ActionIcon>
              }
            ></Indicator>
*/}
            <Avatar
              src={user.avatarUrl}
              size={80}
              radius={40}
              color="orange"
              sx={{ border: '2px solid #eee' }}
            >
              {!user.avatarUrl && getFullNameInitials(user.username)}
            </Avatar>
            <Stack spacing={0} align="center">
              <Text weight={600} size="sm">
                {user.username}
              </Text>
              <Text size="xs" color="dimmed">
                {user.email}
              </Text>
              <Text size="xs" color="orange.4" weight={500} mt={4}>
                {userRoleHumanized?.[user.role]}
              </Text>
            </Stack>
          </Stack>

          <Divider my="sm" />

          <Menu.Item
            onClick={onLogout}
            fw="bold"
            icon={
              <ThemeIcon variant="light" color="violet">
                <IconLogout size={16} />
              </ThemeIcon>
            }
          >
            Sair
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </>
  );
}
